module.exports = __webpack_public_path__ + "img/P150T_weapon_61.8dd6b248.png";